export const CONTENT_TAB_THEMES = {
  home: {
    accent: "#2563eb",
    selected: "#1d4ed8",
    labelBackground: "#dbeafe",
    fieldsItemBorder: "#b0d3f8",
  },
  bonus: {
    accent: "#059669",
    selected: "#047857",
    labelBackground: "#d1fae5",
    fieldsItemBorder: "#a7e8d0",
  },
  twoForOne: {
    accent: "#ed3a3a",
    selected: "#c82020",
    labelBackground: "#fee9e9",
    fieldsItemBorder: "#f8c4c4",
  },
  pastDraws: {
    accent: "#9333ea",
    selected: "#6d28d9",
    labelBackground: "#f3e8ff",
    fieldsItemBorder: "#e4ccff",
  },
} as const;

export const CONTENT_TAB_THEME_CSS_VARS: Record<string, string> = {
  "--content-tab-home-accent": CONTENT_TAB_THEMES.home.accent,
  "--content-tab-home-selected": CONTENT_TAB_THEMES.home.selected,
  "--content-tab-home-label-bg": CONTENT_TAB_THEMES.home.labelBackground,
  "--content-tab-home-fields-border": CONTENT_TAB_THEMES.home.fieldsItemBorder,
  "--content-tab-bonus-accent": CONTENT_TAB_THEMES.bonus.accent,
  "--content-tab-bonus-selected": CONTENT_TAB_THEMES.bonus.selected,
  "--content-tab-bonus-label-bg": CONTENT_TAB_THEMES.bonus.labelBackground,
  "--content-tab-bonus-fields-border": CONTENT_TAB_THEMES.bonus.fieldsItemBorder,
  "--content-tab-two-for-one-accent": CONTENT_TAB_THEMES.twoForOne.accent,
  "--content-tab-two-for-one-selected": CONTENT_TAB_THEMES.twoForOne.selected,
  "--content-tab-two-for-one-label-bg": CONTENT_TAB_THEMES.twoForOne.labelBackground,
  "--content-tab-two-for-one-fields-border": CONTENT_TAB_THEMES.twoForOne.fieldsItemBorder,
  "--content-tab-past-draws-accent": CONTENT_TAB_THEMES.pastDraws.accent,
  "--content-tab-past-draws-selected": CONTENT_TAB_THEMES.pastDraws.selected,
  "--content-tab-past-draws-label-bg": CONTENT_TAB_THEMES.pastDraws.labelBackground,
  "--content-tab-past-draws-fields-border": CONTENT_TAB_THEMES.pastDraws.fieldsItemBorder,
};
